import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { PROFILE } from 'constants/StoreConstants';
import UsuarioService from 'services/UsuarioService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null
}

export const getStart = createAsyncThunk('usuario/start', async (data, { rejectWithValue }) => {
	try {
		const response = await UsuarioService.start()
		localStorage.setItem(PROFILE, JSON.stringify(response));
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const resetSenha = createAsyncThunk('usuario/resetSenha', async (data, { rejectWithValue }) => {
	try {
		const response = await UsuarioService.resetSenha(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao salvar usuário')
	}
})

export const inativar = createAsyncThunk('usuario/inativar', async (data, { rejectWithValue }) => {
	try {
		const response = await UsuarioService.inativar(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao inativar usuário')
	}
})

export const ativar = createAsyncThunk('usuario/ativar', async (data, { rejectWithValue }) => {
	try {
		const response = await UsuarioService.ativar(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao ativar usuário')
	}
})

export const registrarUsuario = createAsyncThunk('usuario/registrar', async (data, { rejectWithValue }) => {
	try {
		const response = await UsuarioService.registrarUsuario(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao registrar usuário')
	}
})

export const listarUsuariosEmpresa = createAsyncThunk('usuario/listarEmpresa', async (data, { rejectWithValue }) => {
	try {
		const response = await UsuarioService.listarUsuariosEmpresa();
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao listar usuários')
	}
})

export const usuarioSlice = createSlice({
	name: 'usuario',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getStart.pending, (state) => {
				state.loading = true
			})
			.addCase(getStart.fulfilled, (state, action) => {
				state.loading = false
			})
			.addCase(getStart.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(registrarUsuario.pending, (state) => {
				state.loading = true
			})
			.addCase(registrarUsuario.fulfilled, (state, action) => {
				state.loading = false
				state.message = 'Usuário registrado com sucesso'
				state.showMessage = true
			})
			.addCase(registrarUsuario.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(listarUsuariosEmpresa.pending, (state) => {
				state.loading = true
			})
			.addCase(listarUsuariosEmpresa.fulfilled, (state, action) => {
				state.loading = false
				state.usuariosEmpresa = action.payload
			})
			.addCase(listarUsuariosEmpresa.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
	},
})

export const {
	authenticated,
	showAuthMessage,
	hideAuthMessage,
	signOutSuccess,
	showLoading,
	signInSuccess
} = usuarioSlice.actions

export default usuarioSlice.reducer